/**
 * Structural Uniform components are interpreted and rendered by the parent form.
 * Returning null prevents a field definition from rendering outside that parent.
 */
export const UniformFormStructuralComponent = () => null;

export default UniformFormStructuralComponent;
